<template>
  <v-card flat class="ma-10 pl-5 pr-5 pt-5 elevation-4">
    <v-card-text class="pa-0 pl-2">
      <v-form
        v-model="is_form_valid"
        :ref="'ref_' + id"
        v-on:submit.prevent="on_submit_form"
      >
        <v-container class="pt-0">
          <v-btn
            icon
            outlined
            ripple
            small
            color="success"
            @click="$emit('on-auto-fill')"
            :disabled="is_loading"
            class="float-right"
          >
            <v-icon>mdi-bug-check-outline</v-icon>
          </v-btn>
          <div class="text-muted mt-0 mb-4 h6" :id="id">
            <b>{{ title }}</b>
          </div>
          <slot>form fields go in here</slot>
          <v-row>
            <v-col
              cols="6"
              class="mt-0 mb-1 pb-0 pt-2 text-left d-flex align-center"
            >
              <slot name="clearbtnslot">
                <v-btn
                  class="hgt-40 round-4"
                  tile
                  filled
                  ripple
                  color="default"
                  @click="on_clear_form"
                  :disabled="is_loading"
                >
                  <v-icon>mdi-cancel</v-icon>
                  Clear
                </v-btn>
              </slot>
            </v-col>
            <v-col cols="6" class="mt-0 mb-1 pb-0 pt-2 text-right">
              <v-btn
                :class="'hgt-40 round-4 ' + (submit_btn_color=='red'?'white--text': '')"
                tile
                filled
                ripple
                type="submit"
                :color="submit_btn_color"
                style="width: 150px"
                :disabled="is_loading"
              >
                {{ submit_btn_text }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <slot name="lower"></slot>
    </v-card-text>
    <v-dialog v-model="show_success_dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline primary--text">
          <v-icon large class="mr-1" color="success">mdi-cloud-check</v-icon>
          Botswana Services</v-card-title
        >
        <v-divider></v-divider>
        <br />
        <v-card-text
          style="font-size: 18px; color: #5a5555"
          class="h4"
          v-html="message"
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            class="hgt-40 round-4"
            tile
            filled
            ripple
            @click="hide_success_dialog"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="show_errors_dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-1">
          <v-icon large class="mr-1" color="red">mdi-alert</v-icon>
          Error Information Display</v-card-title
        >
        <v-divider></v-divider>
        <br />
        <v-card-text v-for="(error, index) in errors" :key="index">
          <div style="font-size: 16px; color: #5a5555" class="h4">
            {{ index + 1 }}) {{ error }}
          </div>
          <v-divider></v-divider>
        </v-card-text>
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            class="hgt-40 round-4"
            tile
            filled
            ripple
            @click="show_errors_dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: "CardedForm",
  props: {
    submit_btn_color: {
      type: String,
      default: "primary",
    },
    submit_btn_text: {
      type: String,
      default: "Submit",
    },
    title: {
      type: String,
      default: "Form",
    },
    id: {
      type: String,
      default: "",
      required: true,
    },
    errors: {
      type: Array,
      default: () => {
        return [];
      },
    },
    message: {
      type: String,
      default: "", //"Your <b class='success--text'>Submission</b> was <b class='success--text'>Successfull</b>"
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      is_form_valid: false,
      show_success_dialog: false,
      show_errors_dialog: false,
    };
  },
  methods: {
    get_form_ref() {
      var form_ref = "ref_" + this.id;
      return form_ref;
    },
    hide_success_dialog() {
      this.show_success_dialog = false;
      this.$emit("on-close-message");
    },
    show_message_dialog(val) {
      this.show_success_dialog = val ? val : true;
    },
    show_error_dialog(val) {
      this.show_errors_dialog = val ? val : true;
    },
    on_clear_form(){
      this.on_clear_validations();
    },
    on_clear_validations(){
      var form_ref = this.get_form_ref();
      this.$refs[form_ref].resetValidation();
    },
    on_clear_form() {
      var form_ref = this.get_form_ref();
      this.$refs[form_ref].reset();
      this.on_clear_validations();
    },
    on_submit_form() {
      var form_ref = this.get_form_ref();
      //console.log("on_submit_form is valid",this.is_form_valid);
      this.$refs[form_ref].validate();
      if (this.is_form_valid == true) {
        this.$emit("on-submit-form", this.is_form_valid);
      }
    },
  },
};
</script>